export const SET_DATA = 'loan-calculator/SET_DATA';

export const SHOW_ADD_EDIT_MODAL = 'loan-calculator/SHOW_ADD_EDIT_MODAL';
export const HIDE_ADD_EDIT_MODAL = 'loan-calculator/HIDE_ADD_EDIT_MODAL';

export const DELETE_CALCULATOR = 'loan-calculator/DELETE_CALCULATOR';
export const CREATE_CALCULATOR = 'loan-calculator/CREATE_CALCULATOR';
export const UPDATE_CALCULATOR = 'loan-calculator/UPDATE_CALCULATOR';
